import HomeIcon from "@mui/icons-material/Home";
import { Container, Stack } from "@mui/material";

import {
	dummyAdvisoryCaseId,
	dummyAdvisoryCaseId2,
} from "AdvisoryManagement/Stores/dummyStore";
import {
	GlobalResources,
	useResource,
} from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { BlButton } from "Shared/Buttons/BlButton";
import { InfoCard } from "Shared/Cards/InfoCard";
import { MainLayout } from "Shared/Layouts/MainLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";

export const HomePage = () => {
	const { t } = useResource();

	return (
		<MainLayout title={t(GlobalResources.HomePage.Title)}>
			<Container maxWidth="md">
				<Stack spacing={3} sx={{ py: 6 }}>
					<InfoCard
						icon={<HomeIcon sx={{ fontSize: 28 }} />}
						title={t(GlobalResources.HomePage.EmptyStateTitle)}
						subtitle={t(GlobalResources.HomePage.EmptyStateSubtitle)}
						customActionButton={
							<Stack direction="row" spacing={2}>
								<UnstyledLink
									to={AppRouting.AdvisoryCase.path(dummyAdvisoryCaseId)}
								>
									<BlButton variant="contained" color="primary">
										{t(GlobalResources.HomePage.DemoCaseButtonA)}
									</BlButton>
								</UnstyledLink>
								<UnstyledLink
									to={AppRouting.AdvisoryCase.path(dummyAdvisoryCaseId2)}
								>
									<BlButton variant="contained" color="primary">
										{t(GlobalResources.HomePage.DemoCaseButtonB)}
									</BlButton>
								</UnstyledLink>
							</Stack>
						}
					/>
				</Stack>
			</Container>
		</MainLayout>
	);
};
